'use client';

import { useState, useEffect } from 'react';

export const useConsentManagement = () => {
  const [consentGiven, setConsentGiven] = useState(false);
  const [consentLoaded, setConsentLoaded] = useState(false);

  useEffect(() => {
    // Check for existing consent
    const existingConsent = document.cookie
      .split('; ')
      .find((row) => row.startsWith('localConsent='))
      ?.split('=')[1];

    setConsentGiven(existingConsent === 'true');
    setConsentLoaded(true);
  }, []);

  return { consentGiven, consentLoaded };
};

export const useUserInteraction = () => {
  const [userInteracted, setUserInteracted] = useState(false);

  useEffect(() => {
    // Don't add listeners if already interacted
    if (userInteracted) return;

    const handleInteraction = () => {
      setUserInteracted(true);
      // Remove all listeners
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('scroll', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
      document.removeEventListener('keydown', handleInteraction);
    };

    // Add interaction listeners with passive option for better performance
    document.addEventListener('click', handleInteraction, {
      passive: true,
      once: true,
    });
    document.addEventListener('scroll', handleInteraction, {
      passive: true,
      once: true,
    });
    document.addEventListener('touchstart', handleInteraction, {
      passive: true,
      once: true,
    });
    document.addEventListener('keydown', handleInteraction, {
      passive: true,
      once: true,
    });

    return () => {
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('scroll', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
      document.removeEventListener('keydown', handleInteraction);
    };
  }, [userInteracted]);

  return userInteracted;
};
